// extracted by mini-css-extract-plugin
module.exports = {"btn":"login_btn__aFwtB","btnText":"login_btnText__3WrL_","errorMessage":"login_errorMessage__2whIK","label":"login_label__21OQL"};